import {
  IDefaultCostCodeStatusEnum,
  IGetDefaultCostCodeCategoriesArgs,
  useGetDefaultCostCodeCategoriesQuery,
} from 'redux-store/api/selections';
import CostCodeSelect from '../cost-code-select/cost-code-select';
import { ICompanyCostCodeSelect } from './types';
import { useCallback, useMemo, useState } from 'react';
import { getCostCodeOptionLabel } from '../cost-code-select/utils';

const getDefaultCostCodesParams = (): IGetDefaultCostCodeCategoriesArgs => ({
  status: IDefaultCostCodeStatusEnum.ACTIVE,
  withCostCodes: true,
  search: undefined,
});

export const CompanyCostCodeSelect = ({ ...props }: ICompanyCostCodeSelect) => {
  const [defaultCostCodesParams, setDefaultCostCodesParams] =
    useState<IGetDefaultCostCodeCategoriesArgs>(() => getDefaultCostCodesParams());

  const { data: defaultCostCodesData, isFetching: isCostCodesFetching } =
    useGetDefaultCostCodeCategoriesQuery(defaultCostCodesParams);

  const formattedDefaultCostCodesOptions = useMemo(() => {
    if (!defaultCostCodesData) return [];

    return defaultCostCodesData.items.flatMap(({ number, companyCostCodes = [] }) =>
      companyCostCodes.map(({ id, name: itemName, number: costCodeNumber }) => ({
        label: getCostCodeOptionLabel({
          categoryNumber: number,
          costCodeNumber,
          costCodeName: itemName,
        }),
        value: id,
      }))
    );
  }, [defaultCostCodesData]);

  const resetCostCodesParams = useCallback(() => {
    setDefaultCostCodesParams(getDefaultCostCodesParams());
  }, []);

  return (
    <CostCodeSelect
      isCostCodesFetching={isCostCodesFetching}
      options={formattedDefaultCostCodesOptions}
      resetCostCodesParams={resetCostCodesParams}
      setCostCodesParams={setDefaultCostCodesParams}
      {...props}
    />
  );
};
